import { useLayoutEffect, useRef, useState } from 'react';
import { Tag } from '@timeedit/ui-components';
import { Flex, Tooltip, theme } from '@timeedit/ui-components/antd';

const { useToken } = theme;

export const DataTags = ({ data }: { data: string[] }) => {
  const { token } = useToken();
  const listRef = useRef<HTMLDivElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = listRef.current;
    if (!el) return;
    const check = () => setOverflowing(el.scrollWidth - el.clientWidth > 1);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [data]);

  if (!data || data.length === 0) return null;

  return (
    <Flex align="center" style={{ minWidth: 0 }}>
      <div
        ref={listRef}
        style={{
          display: 'flex',
          gap: token.marginXS,
          overflow: 'hidden',
          minWidth: 0,
          flex: 1,
        }}
      >
        {data.map((item) => (
          <Tag key={item} style={{ height: 21, margin: 0, flexShrink: 0 }}>
            {item}
          </Tag>
        ))}
      </div>
      {overflowing && (
        <Tooltip title={data.join(', ')}>
          <span
            style={{
              flexShrink: 0,
              paddingInline: token.marginXXS,
              cursor: 'default',
              color: token.colorTextSecondary,
            }}
          >
            …
          </span>
        </Tooltip>
      )}
    </Flex>
  );
};
